import { Button } from 'primereact/button'
import React from 'react'
import Spinner from './Spinner'
import { useTranslation } from 'react-i18next'

const buttonTypeClasses = {
  primary: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-primary text-white capitalize border-primary !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-primary'
  },
  gradient: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-gradient text-white capitalize border-[#0070C2] !outline-none !shadow-none !font-[400]',
    hover: '!hover:bg-white hover:text-primary '
  },
  success: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-success text-white capitalize border-success !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-success'
  },
  blue: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-blue text-white capitalize border-blue !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-blue'
  },
  default: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-primary text-white capitalize border-primary !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-primary'
  },
  reset: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 !bg-gray-500 text-white capitalize border-gray-500 !outline-none !shadow-none',
    hover: '!hover:bg-gray-500'
  },
  danger: {
    base: 'rounded-md !py-0 !h-[30px] !px-2.5 bg-red-500 text-white capitalize border-red-500 !outline-none !shadow-none',
    hover: '!hover:bg-white hover:text-red-500'
  }
}

const CustomButton = ({
  label = '',
  className = '',
  type = 'button',
  onClick,
  icon = '',
  buttonType = 'default',
  loading = false,
  disabled = false,
  loadingText = 'Loading',
  iconClassName = "",
  LoadingIcon = <Spinner />,
  pt = {},
  showLoadingText = true,
  ...props
}) => {
  const { base, hover } =
    buttonTypeClasses[buttonType] || buttonTypeClasses.default
  const { t } = useTranslation()
  return (
    <Button
      label={
        loading ? (
          <span className='flex gap-2 items-center'>
            {showLoadingText &&
              (typeof loadingText === 'string' ? t(loadingText) : loadingText)}{' '}
            {LoadingIcon}
          </span>
        ) : typeof label === 'string' ? (
          t(label)
        ) : (
          label
        )
      }
      className={` ${base} ${hover} ${className} `}
      type={type}
      onClick={onClick}
      icon={loading ? null : icon}
      disabled={disabled || loading}
      pt={{
        root: { className: 'hover:bg-white' },
        label: { className: '!font-[500] whitespace-nowrap ms-1' },
        icon: { className: `mx-2 ${iconClassName}` },
        ...pt
      }}
      {...props}
    />
  )
}

export default CustomButton
